<section class="main-wrap inner-views dashboard-wrap new-sidebar" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap filter-container">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
        <div class="filters-wrap">
          <ng-container >
            <app-shoe-filters [shoeFilterOptions]="shoesFilterOptions" (filterEvent)="filterData($event)" ></app-shoe-filters>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="content-container products-container safety-shoes">
      <div class="row">
        <div class="col-md-12 dash-title">
          <h1>
            Safety Shoes
          </h1>
        </div>
        <div class="clearfix"></div>
        @for (shoe of shoes; track $index; let i = $index) {
          <div class="col-md-4">
            <div class="shop-tile">
              <div class="carousel slide carousel-fade" id="product_{{i}}">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <a [routerLink]="['/products/safety-shoes', shoe.style]" (click)="selectProduct(shoe.id, shoe.style)">
                      <img class="d-block w-100" [attr.src]="shoe.shoeImages.imageMain" loading="lazy"/>
                    </a>
                  </div>
                </div>
              </div>
              <h3>{{shoe.brand}} <span class="app-price">{{shoe.price | currency}}</span></h3>
              <a class="tile-link"
                [routerLink]="['/products/safety-shoes', shoe.style]"
                (click)="selectProduct(shoe.id, shoe.style)">{{shoe.style}}
              </a>
            </div>
          </div>
        }
        <div class="clearfix"></div>
        @if (totalItems) {
          <div class="col-md-12 product-pagination">
            <app-product-pagination [currentPage]="currentPage" [pageSize]="30" [items]="totalItems" (pageChangeEvent)="pageChange($event)"></app-product-pagination>
          </div>
        }
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</section>
